package com.jet.classroomhero.entities

import kotlinx.serialization.Serializable

@Serializable
data class Tokens(
    val access: String = "",
    val refresh: String = "")